import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { useState as E } from "react";
import { c as t } from "./index-DkZ16bcJ.mjs";
import { L as O } from "./layout-box-DFBM-kSI.mjs";
import { m as I } from "./tss-DN0acMKN.mjs";
import { M as f, d } from "./constants-CnFYFetN.mjs";
import { S as P } from "./Slider-CwXiUmiw.mjs";
const T = I()(({ borderRadiuses: u, constructs: a, mixins: l, mode: n, palette: r, typography: o }, { staticLabels: b }) => {
  var y, k;
  const s = e.ifFeature("encore", (y = o.medium) == null ? void 0 : y.fontSize, (k = o.small) == null ? void 0 : k.fontSize), p = 8, h = e.ifFeature("encore", 20, 22), g = e.ifFeature("encore", 24, 22);
  return {
    valueLabel: {
      backgroundColor: "unset",
      fontSize: s,
      fontWeight: o.fontWeightSemibold,
      lineHeight: "22px",
      top: e.ifFeature("encore", 50, 52),
      "&:before": {
        display: "none"
      },
      "& *": {
        background: "transparent",
        color: n === f.Dye ? d.main : e.ifFeature("encore", a.text.primary.strong, r.primary.main)
      }
    },
    mark: {
      backgroundColor: e.ifFeature("encore", a.surface.neutral.medium, r.grey[400]),
      height: e.ifFeature("encore", 4, 22),
      width: e.ifFeature("encore", 2, 22),
      borderRadius: e.ifFeature("encore", u[100], u[800]),
      margin: e.ifFeature("encore", 0, "0 0 0 -10px"),
      "&.MuiSlider-markActive": {
        opacity: 1,
        backgroundColor: e.ifFeature("encore", a.surface.primary.strong, r.primary.main)
      }
    },
    markDisabled: {
      "&.MuiSlider-markActive": {
        opacity: 0
      }
    },
    markLabel: {
      color: e.ifFeature("encore", a.text.neutral.xWeak, r.grey[500]),
      display: e.ifFeature("encore", b ? "none" : void 0),
      fontSize: s,
      fontWeight: e.ifFeature("encore", void 0, o.fontWeightSemibold),
      top: 29,
      "&.MuiSlider-markLabelActive": {
        color: "transparent"
      }
    },
    rail: {
      opacity: 1,
      height: p,
      backgroundColor: e.ifFeature("encore", a.surface.neutral.weak, r.grey[400])
    },
    root: {
      color: e.ifFeature("encore", a.surface.primary.medium, r.primary.lightest),
      height: 3,
      padding: "15px 0"
    },
    thumb: {
      height: h,
      width: g,
      backgroundColor: n === f.Dye ? d.main : e.ifFeature("encore", a.surface.primary.strong, r.primary.main),
      border: e.ifFeature("encore", l.border(2, a.border.neutral.forcedWhite)),
      borderRadius: u[800],
      boxSizing: e.ifFeature("encore", "content-box"),
      "&.Mui-disabled": {
        height: h,
        width: g,
        backgroundColor: n === f.Dye ? d.light : e.ifFeature("encore", a.surface.neutral.medium, r.grey[400]),
        color: e.ifFeature("encore", a.surface.neutral.medium, r.grey[400]),
        "& .MuiSlider-valueLabel span": {
          color: e.ifFeature("encore", a.surface.neutral.medium, r.grey[400]),
          "& *": {}
        }
      },
      "&.Mui-focusVisible": {
        boxShadow: `0px 0px 0px 4px ${e.ifFeature(
          "encore",
          l.alpha(a.surface.primary.medium, 0.1),
          l.alpha(r.primary.lightest, 0.35)
        )}`
      },
      "&:before": {
        content: e.ifFeature("encore", "none")
      },
      "&:hover": {
        boxShadow: `0px 0px 0px 4px ${e.ifFeature(
          "encore",
          l.alpha(a.surface.primary.medium, 0.1),
          l.alpha(r.primary.lightest, 0.35)
        )}`
      }
    },
    track: {
      backgroundColor: n === f.Dye ? d.lightest : void 0,
      border: "none",
      height: e.ifFeature("encore", p, 12)
    },
    customLabelsWrapper: {
      position: "relative",
      width: "100%",
      top: "-16px"
    },
    customLabel: {
      position: "absolute",
      fontSize: s,
      fontWeight: o.fontWeightSemibold,
      color: n === f.Dye ? d.main : e.ifFeature("encore", a.text.primary.strong, r.primary.main)
    },
    leftLabel: {
      left: -4,
      top: 5
    },
    rightLabel: {
      right: -4,
      top: 5
    }
  };
}), _ = (u) => {
  const {
    ariaDescribedby: a,
    biId: l,
    className: n,
    classes: r = {},
    defaultValue: o,
    disabled: b,
    disableSwap: s,
    getAriaLabel: p,
    getAriaValueText: h,
    marks: g,
    max: y,
    min: k,
    name: w,
    onChange: v,
    onChangeCommitted: A,
    step: M,
    scale: j,
    staticLabels: F,
    value: L,
    valueLabelDisplay: V,
    valueLabelFormat: m,
    ...$
  } = u;
  let C = g, S = V;
  const [N, z] = E(o), D = (Array.isArray(L) || Array.isArray(o)) && F, x = L || N, { classes: i } = T({ staticLabels: F });
  F && (e.isEnabled("encore") || (C = !1), S = "off");
  const H = (R, W, B) => {
    o !== void 0 && z(W), typeof v == "function" && v(R, W, B);
  };
  return /* @__PURE__ */ c.jsxs(
    O,
    {
      "data-fabric-component": "SliderSelect",
      paddingBottom: e.ifFeature("encore", D || S !== "off" ? "12px" : 0),
      width: "100%",
      children: [
        /* @__PURE__ */ c.jsx(
          P,
          {
            ...$,
            classes: {
              mark: t(i.mark, r.mark, { [i.markDisabled]: b }),
              markLabel: t(i.markLabel, r.markLabel),
              rail: t(i.rail, r.rail),
              root: t(i.root, r.root),
              thumb: t(i.thumb, r.thumb),
              track: t(i.track, r.track),
              valueLabel: t(i.valueLabel, r.valueLabel)
            },
            className: t(i.root, n),
            defaultValue: o,
            disabled: b,
            disableSwap: s,
            getAriaLabel: p,
            getAriaValueText: h,
            marks: C,
            max: y,
            min: k,
            name: w,
            onChange: H,
            onChangeCommitted: A,
            scale: j,
            slotProps: { input: { "data-bi-id": l, "aria-describedby": a } },
            step: M,
            value: L,
            valueLabelDisplay: S,
            valueLabelFormat: m
          }
        ),
        D && /* @__PURE__ */ c.jsxs("div", { className: i.customLabelsWrapper, children: [
          /* @__PURE__ */ c.jsx("span", { className: `${i.customLabel} ${i.leftLabel}`, children: typeof m == "function" ? m(x[0], 0) : x[0] }),
          /* @__PURE__ */ c.jsx("span", { className: `${i.customLabel} ${i.rightLabel}`, children: typeof m == "function" ? m(x[1], 1) : x[1] })
        ] })
      ]
    }
  );
};
export {
  _ as S
};
//# sourceMappingURL=slider-select-DkqraHqW.mjs.map
